// Module
var code = "<react-file-manager owner-id=\"ctrl.ownerId\" owner-type=\"ctrl.ownerType\"></react-file-manager>";
// Exports
module.exports = code;